export enum PartyTypeCode {
  INDIVIDUAL = 'P',
  INSTITUTION = 'I'
}

export enum Status {
  NOT_START = 'N',
  FAIL = 'F',
  SUCCESS = 'S',
  CRITICAL = 'X',
  INQUEUE = 'I'
}

export enum SortableHeader {
  PRODUCT_TYPE = 'productType',
  CONTRACT_NO = 'contractNo',
  IDCARD_NO = 'idCardNo',
  FIRSTNAME = 'firstName',
  EXPIRED_DATE = 'expiredDate',
  LAST_SENT_DATE = 'lastSentDate',
  SENT_BY = 'sentBy',
  DOCUMENT_TYPE = 'docType'
}

export enum DocType {
  EPOLICY = 'ePolicy',
  ERENEWALNOTICE = 'eRenewalNotice',
  PA_TAXDEDUCT = 'PA_TAXDEDUCT'
}
